import * as _ from 'lodash'
import {
    IBusinessObject,
    IBusinessObjectChanges,
    IBusinessObjectChangesOptions
} from "../PA.Core/PA.Core.IF.BO";
import { IEntitySource, IMessageProvider, IProgressProvider, MessageType } from "../PA.Core/PA.Core.IF.Basic";
import { PAdbContext } from '../PA.Core/PAdbContext';
import { IdentityProvider } from '../PA.Core/Basic/Identity'
import { MessageProvider } from '../PA.Core/Basic/Messages'
import { ProgressProvider } from '../PA.Core/Basic/Progress'
import {
    WB_PlanRow,
    WB_FC_OverrideRow,
    WB_ProductGroupRow,
    WB_CustomerRow,
    WB_PlanProductGroupRow,
    WB_FC_Override_CustomerRow,
    WB_FC_Override_ProductRow,
    WB_FC_Override_ConsumptionRow, WB_PlanProductRow
} from '../PA.Core/PAdbSchemaRows'
import {
    esWB_Customer,
    esWB_FC_Override,
    esWB_FC_Override_Consumption,
    esWB_FC_Override_Customer,
    esWB_FC_Override_Event_Date,
    esWB_FC_Override_Event_Merge,
    esWB_FC_Override_Event_Product,
    esWB_FC_Override_Event_Spend,
    esWB_FC_Override_Event_Spend_Redistribution,
    esWB_FC_Override_Event_Volume,
    esWB_FC_Override_Product,
    esWB_Plan, esWB_Plan_Product,
    esWB_Plan_Product_Group,
    esWB_Plan_Type,
    esWB_Product_Group
} from '../PA.Core/PAdbSchema'
import { ESRecord } from "../PA.Core/lib/ESRecord";
import { ESDataStore } from "../PA.Core/lib/ESDataStore";
import { CreateOptions, ESRecordResolver } from "../PA.Core/lib/ESRecordResolver";
import { ASync } from "../PA.Core/Basic/ASync";

import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { DefaultChanges } from "../PA.Core/BusinessObject/BusinessObjectChanges";
import { BehaviorSubject, Subscription } from "rxjs";
import { CubeSource } from "../PA.HyperRectangle.Core/CubeSource";
import { ExecutionSerializer } from "../PA.Core/Basic/ExecutionSerializer";
import { DimensionType } from "../PA.Core/PA.Core.IF.Hierarchy";
import { ICubePerspectiveOptions, ICubeSource } from "../PA.HyperRectangle.Core/PA.HyperRectangle.IF";
import { DataSourceJSData } from "../PA.HyperRectangle.Core/DataSourceJSData";
import * as AsyncLock from "async-lock";
import { PASearch } from "../PA.Core/PASearch";
import { DateUtils } from "../PA.Core/Basic/Dates";
import { IPolicyCollection } from "../PA.Core/PA.Core.IF.Policy";
import { IHaveSecurity } from "../PA.Core/PA.Core.IF.Aspects";
import { PolicyHasRole } from "../PA.Core/Security/PolicyHasRole";
import { PolicyBOis } from "../PA.Core/Security/PolicyBOis";
import { PolicyCollection } from "../PA.Core/Security/PolicyCollection"
import { ErrorMessage_restate, ExceptionMessage_restate } from '../PA.Core/Basic/MessageUtils'
import { DimensionPlacement } from "../PA.Reporting.Core/PA.Reporting.IF";
import { IwbFCOverride, IwbFCOverrideConsumption } from '../PA.Core/PAdbSchemaRowsIF'
import { SourceCustomerService } from '../PA.MD.Services/SourceCustomerService'
import { MetricParameters, MetricsParameterSet } from '../PA.Metric.Services/PAMetrics'
import { PAMetricServiceClient } from '../PA.Metric.Services/PAMetricServiceClient'

const sleep = (ms: number) =>
    new Promise(resolve => setTimeout(resolve, ms));

export interface IConsumptionOverrideCopyOptions {

}

export interface IConsumptionOverrideLoadNewOptions {
    dbContext?: PAdbContext
    WB_PLAN_ID?: number
    arrWB_CUST_ID_SOURCE?: number[],
    arrWB_PRDGRP_ID?: number[],
    startDt?: Date,
    endDt?: Date
}

export interface IConsumptionOverrideCreateOptions {

}

export interface IConsumptionPeriod {
    key: string,  // End Dt
    name: string,

    startDt: Date
    endDt: Date
}

interface vUI_Plan_Cnsmp_Period_DatesRow {
    WB_PLAN_ID: number,
    WB_CUST_ID_PLANNING: number,
    START_DT: string,
    END_DT: string,
}


export class ConsumptionOverrideBO
    implements
        IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: IConsumptionOverrideCreateOptions;

    LoadOptions: IConsumptionOverrideLoadNewOptions;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drOverride: WB_FC_OverrideRow;


    constructor(options?: IConsumptionOverrideCreateOptions) {

        this.CreateOptions = options || {};

        this.Identity = new IdentityProvider({ id: 0, name: 'New Consumption Override' });

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drOverride = undefined;

        this.IHaveSecurity_init();
        this.CustomerProducts_init();
        this.Period_init();
        this.ICubeSourceOverride_init();

    }


    get WB_Override(): WB_FC_OverrideRow {
        return this.drOverride;
    }

    //<editor-fold desc = "IBusinessObject operations">

    async LoadNew(options?: IConsumptionOverrideLoadNewOptions): Promise<IBusinessObject> {
        const self = this;

        self.LoadProgressProvider.start("Creating Override");
        const rv = self._OnLoadComplete = (async () => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (_.isEmpty(self.dbContext)) {
                const sError = "Unable to determine dbContext for new Override.";
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(sError);
                return self;
            }

            try {
                // Create record using dbContext
                let wbPlanId = +options?.WB_PLAN_ID
                let planRow: WB_PlanRow

                if(_.isNumber(wbPlanId)){
                    planRow = await self.dbContext.find(esWB_Plan,  wbPlanId);

                }

                if(_.isEmpty(planRow)) {
                    // Error
                    const sError = "Unable to determine plan for new Override.";
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(sError);
                    return self;
                }

                const ovrdRow: WB_FC_OverrideRow = <WB_FC_OverrideRow> await self.dbContext.createRecordWithKey(esWB_FC_Override)
                ovrdRow.setDefaults()
                ovrdRow.cif.OVRD_TYPE = 'Plan Cnsmp'
                ovrdRow.cif.WB_PLAN_ID = wbPlanId;
                ovrdRow.WB_PlanRow = planRow
                ovrdRow.CnsStartDt = planRow.InStore.Range.StartDt
                ovrdRow.CnsEndDt = planRow.InStore.Range.EndDt
                if(_.isDate(options?.startDt))
                    ovrdRow.CnsStartDt = options?.startDt
                if(_.isDate(options?.endDt))
                    ovrdRow.CnsEndDt = options?.endDt

                self.drOverride = ovrdRow;
                self.dbContext.add(esWB_FC_Override, ovrdRow)
                self.Identity.setAll(self.WB_Override.cif.WB_OVRD_ID, self.WB_Override.cif.OVRD_ID, self.WB_Override.cif.OVRD_ID);
                self.Identity.listenToRecordUpdates(self.WB_Override, "WB_OVRD_ID", "OVRD_ID", "OVRD_ID");
                self.Identity.createdBy = self.WB_Override.cif.WB_AUTHUSR_ID_CREATEDBY

                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                let po = ovrdRow.PerspectiveOptions
                let to = ovrdRow.TableOptions

                let briefMetricIds =  [... _.map(['SYND_CNS_BASE_UNITS', 'SYND_CNS_INCR_UNITS','SYND_CNS_TOTAL_UNITS',
                    'BASE_OVRD','MERCH_INCR_OVRD'], (a) => `Overrides_${a}`),
                    'Override_Total_Override']


                po.Dimensions = {
                    // Customer: { LevelId: 'Source' },
                    Product: { LevelId: 'ProductGroup' }
                }
                to.DimensionOptions = {
                    Product: {
                        DimensionType: DimensionType.Product,
                        Placement: DimensionPlacement.OnRows,
                        bShowIds: true
                    }
                }
                to.RowDimensionKeyOrder = [DimensionType.Product];
                to.ColumnDimensionKeyOrder = [];
                po.MetricIds = _.clone(briefMetricIds)
                to.MetricPlacement = DimensionPlacement.OnColumns
                to.MetricOrder = po.MetricIds
                ovrdRow.PerspectiveOptions = po
                ovrdRow.TableOptions = to

                await self._AfterBoLoadCompleteInternal()
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;

                // Add Event PGs and Source Customers
                if(!_.isEmpty(options?.arrWB_CUST_ID_SOURCE)){
                    for(let wbCustId of options.arrWB_CUST_ID_SOURCE){
                        await self.addCustomer(wbCustId);
                    }
                }
                if(!_.isEmpty(options?.arrWB_PRDGRP_ID)){
                    for(let wbPrdGrpId of options.arrWB_PRDGRP_ID){
                        await self.addProductGroup(wbPrdGrpId);
                    }
                }

                self.LoadProgressProvider.finish();
               
                return self;
            } catch (err) {
                self.LoadProgressProvider.exception(err)
                return self
            }

        })();

        return rv;
    }

    async Load(anId: number , options?: object): Promise<IBusinessObject> {
        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        const rv = self._OnLoadComplete = (async () => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if (self.bIsLoaded) {
                self.LoadProgressProvider.exception("Consumption Override already loaded.");
                self._OnLoadComplete = undefined;
                return self;
            }

            self.LoadOptions = options || {};

            try {
                if ('dbContext' in self.LoadOptions)
                    self.dbContext = self.LoadOptions.dbContext;
                else if (_.isEmpty(self.dbContext)) {
                    self.dbContext = new PAdbContext({});
                }

                if (_.isEmpty(self.dbContext)) {
                    self.LoadProgressProvider.exception("Unable to determine dbContext for Consumption Override.");
                    return self;
                }


                if ('RecordResolver' in self.LoadOptions) {
                    recordResolver = (<any>self.LoadOptions).RecordResolver
                    recordResolverLoadPromise = ASync.resolve()
                } else {
                    recordResolver = ConsumptionOverrideBO.createRecordResolver({ dbContext: self.dbContext })
                    recordResolverLoadPromise = ConsumptionOverrideBO.setupRecordResolver(recordResolver, [anId])
                }


                await recordResolverLoadPromise
                const aOvrdRow: any = recordResolver.get(esWB_FC_Override, anId)

                if (_.isEmpty(aOvrdRow)) {
                    throw "Consumption Override not found";
                }

                self.drOverride = aOvrdRow;
                self.Identity.setAll(self.WB_Override.cif.WB_OVRD_ID, self.WB_Override.cif.OVRD_ID, self.WB_Override.cif.OVRD_ID);
                self.Identity.listenToRecordUpdates(self.WB_Override, "WB_OVRD_ID", "OVRD_ID", "OVRD_ID");
                self.Identity.createdBy = self.WB_Override.cif.WB_AUTHUSR_ID_CREATEDBY

                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                await self._AfterBoLoadCompleteInternal()
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.finish();
                await self.OnICubeSourceOverrideLoaded
                return self;
            } catch
                (err) {
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(err);
                throw err
            }

        })();

        return rv;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {
        const self = this;

        self.ValidateMessageProvider.clearMessages();
        self.ValidateProgressProvider.start("Validating " + self.WB_Override.cif.OVRD_ID + "(" + self.WB_Override.cif.OVRD_ID + ")");

        self.ValidateOptions = options || {};
        try {
            if (_.isEmpty(self.dbContext)) {
                const sError = "Unable to determine dbContext for to Validate Consumption Override.";
                self.ValidateProgressProvider.exception(sError);
                return self;
            }
            //await ConsumptionOverrideBOValidations.Validate(self)

            self._bIsValidated = (self.ValidateMessageProvider.countMessages(MessageType.Error) == 0)
            self.ValidateProgressProvider.finish();

        } catch (err) {
            self.ValidateMessageProvider.addMessage({
                code: 'Exception',
                type: MessageType.Error,
                description: JSON.stringify(err),
                title: 'Validation Exception'
            })
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);
        }

        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;

        self._bIsSaved = false
        const wbConsumptionOverride = <IwbFCOverride>self.drOverride;
        self.SaveProgressProvider.start("Saving " + wbConsumptionOverride.OVRD_ID + "(" + wbConsumptionOverride.OVRD_ID + ")");
        try {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if (_.isEmpty(this.dbContext)) {
                const sError = "Unable to determine dbContext to Save Consumption Override.";
                self.SaveProgressProvider.exception(sError);
                return self
            }
            self.SaveOptions = options || {};

            await self.Validate(options)
            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                self.SaveProgressProvider.finish();
                return self
            }

            if (self.WB_Override.cif.OVRD_STATUS == "New") {
                if(self.WB_Override.cif.DEACTIVATE_IND == '1')
                    self.WB_Override.cif.OVRD_STATUS = "Deactivated";
                else
                    self.WB_Override.cif.OVRD_STATUS = "Pending";
            }

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            await saveFunction(esWB_FC_Override, self.drOverride, {})

            const tasks: Promise<any>[] = []

            tasks.push(saveFunction(esWB_FC_Override_Customer, self.drOverride.WB_FCOverrideCustomerScopeRows))
            tasks.push(saveFunction(esWB_FC_Override_Product, self.drOverride.WB_FCOverrideProductScopeRows))
            tasks.push(saveFunction(esWB_FC_Override_Consumption, self.drOverride.WB_FC_Override_ConsumptionRows))

            await Promise.all(tasks)


            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true;
                })
            } else {
                self._bIsSaved = true;
            }
            self.SaveProgressProvider.finish();
            return self;
        } catch (err) {
            self.SaveProgressProvider.exception(err);
            return self
        }

    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }


//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private async DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;

        const ovrd = <IwbFCOverride>self.drOverride;

        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + ovrd.OVRD_ID + "(" + ovrd.OVRD_ID + ")");

        try {
            // 1. Validate if we can delete the Override
            //await ConsumptionOverrideBOValidations.ValidateDelete(self)
            if (self.DeleteMessageProvider.countMessages(MessageType.Error) > 0) {
                return self
            }

            // 2. If Valid, mark all the records for deletion.
            self.drOverride.markDeleted()
            _.forEach(self.drOverride.WB_FCOverrideCustomerScopeRows, (a) => a.markDeleted())
            _.forEach(self.drOverride.WB_FCOverrideProductScopeRows, (a) => a.markDeleted())
            _.forEach(self.drOverride.WB_FC_Override_ConsumptionRows, (a) => a.markDeleted())


            if (bSaveNow) {
                await self.SaveUsing(false)

                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                return (self);
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                return self;
            }

        } catch (err) {
            self.DeleteProgressProvider.exception(err)
            return self
        }
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    private async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;

        self.LoadProgressProvider.setProgressMessage('ConsumptionOverrideBO.PostLoad', 'Processing Loaded Data');


        await self.IHaveSecurity_OnLoadComplete()

        const tasks: Promise<any>[] = [];
        tasks.push(self.CustomerProducts_OnLoadComplete())
        tasks.push(self.Period_OnLoadComplete())
        await Promise.all(tasks)
        await self.ICubeSource_OnLoadComplete();

        return
    }


    //</editor-fold>

    //<editor-fold desc = "IHaveSecurity operations">

    private _PolicyCollection: IPolicyCollection;
    private _bIHaveSecurityLoaded: boolean;
    private _OnIHaveSecurityLoaded: Promise<IHaveSecurity>

    //private _Lock: ILock

    IHaveSecurity_init() {
        this._PolicyCollection = new PolicyCollection()
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
        //this._Lock = undefined
    }

    IHaveSecurity_beforeReload() {
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
    }

    async IHaveSecurity_OnLoadComplete(): Promise<void> {
        const self = this

        await self.OnIHaveSecurityLoaded
    }

    get OnIHaveSecurityLoaded(): Promise<IHaveSecurity> {
        const self = this

        if (this.bIHaveSecurityLoaded) {
            return ASync.resolve(this)
        }

        if (this._OnIHaveSecurityLoaded) {
            return this._OnIHaveSecurityLoaded
        }

        let aHasRolePolicy: PolicyHasRole;
        this._OnIHaveSecurityLoaded = (async () => {
            const aBOis = new PolicyBOis(["Super_User", "Application_User"], []);
            self._PolicyCollection.addPolicy("BOis", aBOis);
            aHasRolePolicy = new PolicyHasRole();
            await aHasRolePolicy.OnLoadComplete;
            self._PolicyCollection.addPolicy("HasRole", aHasRolePolicy);
            this._bIHaveSecurityLoaded = true;
            return self;
        })();

        return this._OnIHaveSecurityLoaded
    }

    get PolicyCollection(): IPolicyCollection {
        return this._PolicyCollection
    }

    get bIHaveSecurityLoaded(): boolean {
        return this._bIHaveSecurityLoaded
    }


//</editor-fold>

    //<editor-fold desc = "BO Changes operation">

    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        const opts = options || {}
        opts.dctIncludeBelongsToNamedRelations = opts.dctIncludeBelongsToNamedRelations || {}
        opts.dctExcludeFields = opts.dctExcludeFields || {}
        opts.dctIgnoreChanges = opts.dctIgnoreChanges || {}

        // Set any BO Specific change settings
        return DefaultChanges(this, this.WB_Override, opts)
    }


    //</editor-fold>

    //<editor-fold desc = "Add Remove Customer, Product operations">

    private _allCustomers: WB_CustomerRow[]
    private _allProductGroups: WB_ProductGroupRow[]
    private _dctWbProductIds:{[wbPrdGrpId: number]: number[]}
    private _onCustomersChanged: BehaviorSubject<ConsumptionOverrideBO>
    private _onProductsChanged: BehaviorSubject<ConsumptionOverrideBO>
    private custEntitySource: IEntitySource
    private prdEntitySource: IEntitySource

    private CustomerProducts_init() {
        this._allCustomers = []
        this._allProductGroups = []
        this._dctWbProductIds = {}
        this._onCustomersChanged = new BehaviorSubject<ConsumptionOverrideBO>(undefined)
        this._onProductsChanged = new BehaviorSubject<ConsumptionOverrideBO>(undefined)
    }

    private async CustomerProducts_OnLoadComplete(): Promise<void> {
        const self = this

        //
        let planRow = self.WB_Override.WB_PlanRow
        if (_.isEmpty(planRow))
            return


        // Get Plan Source Customers and Product Groups
        const aSourceCustomerService = new SourceCustomerService();
        let arrSourceCustomerIds = await aSourceCustomerService.getSrcCustIdsbyParent([planRow.cif.WB_CUST_ID_PLANNING]);
        let arrSourceCustomers: WB_CustomerRow[] = []
        if(!_.isEmpty(arrSourceCustomerIds)) {
            arrSourceCustomers = await self.dbContext.findAll(esWB_Customer, {
                where: { WB_CUST_ID: { inq: arrSourceCustomerIds } }
            });
        }
        let planPrdGrps = <WB_PlanProductGroupRow[]>await self.dbContext.findAll(esWB_Plan_Product_Group, {
            where: {
                WB_PLAN_ID: planRow.cif.WB_PLAN_ID,
                DELETED_IND: { neq: '1' }
            }
        })
        let wbPlnPrdGrpIds = _.map(planPrdGrps, (rel) => rel.cif.WB_PLANPG_ID)
        if(!_.isEmpty(wbPlnPrdGrpIds)) {
            let dctPlnPG = _.keyBy(planPrdGrps, (rel) => rel.cif.WB_PLANPG_ID)
            let arrPlanProducts: WB_PlanProductRow[] = await self.dbContext.findAll(esWB_Plan_Product, {
                where: { WB_PLANPG_ID: { inq: wbPlnPrdGrpIds },
                    DELETED_IND: { neq: '1' } }
            });

            for(let plnPrd of arrPlanProducts){
                let plnPG = dctPlnPG[plnPrd.cif.WB_PLANPG_ID]
                let wbPrdGrpId = plnPG.cif.WB_PRDGRP_ID
                let wbPrdId = plnPrd.cif.WB_PROD_ID
                if((wbPrdGrpId > 0) && (wbPrdId > 0)){
                    if(wbPrdGrpId in self._dctWbProductIds)
                        self._dctWbProductIds[wbPrdGrpId].push(wbPrdId)
                    else
                        self._dctWbProductIds[wbPrdGrpId] = [wbPrdId]
                }
            }

        }

        let wbPrdGrpIds = _.map(planPrdGrps, (rel) => rel.cif.WB_PRDGRP_ID)
        let arrProductGroups: WB_ProductGroupRow[] = []
        if(!_.isEmpty(wbPrdGrpIds)) {
            arrProductGroups = await self.dbContext.findAll(esWB_Product_Group, {
                where: { WB_PRDGRP_ID: { inq: wbPrdGrpIds } }
            });
        }


        this._allCustomers = arrSourceCustomers || []
        this._allProductGroups = arrProductGroups || []

        this.custEntitySource = {
            get Entities() {
                return self.AllCustomers
            },
            get Selected() {
                return self.Customers
            },
            keyFields: {
                id: 'WB_CUST_ID',
                id_ui: 'CUSTOMER_ID',
                name: 'CUSTOMER_NAME'
            },
            onChange: this.OnCustomersChanged,
            addSelection(id: number): Promise<void> {
                return <any>self.addCustomer(id)
            },
            removeSelection(id: number): Promise<void> {
                return self.removeCustomer(id)
            }

        }


        this.prdEntitySource = {
            get Entities() {
                return self.AllProductGroups
            },
            get Selected() {
                return self.ProductGroups
            },
            keyFields: {
                id: 'WB_PRDGRP_ID',
                id_ui: 'PRODUCT_GROUP_ID',
                name: 'PRODUCT_GROUP_NAME'
            },
            onChange: this.OnProductsChanged,
            addSelection(id: number): Promise<void> {
                return <any>self.addProductGroup(id)
            },
            removeSelection(id: number): Promise<void> {
                return self.removeProductGroup(id)
            }
        }

    }

    get OnCustomersChanged(): BehaviorSubject<ConsumptionOverrideBO> {
        return this._onCustomersChanged
    }

    get OnProductsChanged(): BehaviorSubject<ConsumptionOverrideBO> {
        return this._onProductsChanged
    }

    get AllCustomers(): WB_CustomerRow[] {
        return this._allCustomers
    }

    get Customers(): WB_CustomerRow[] {
        return _.map(_.filter(this.WB_Override.WB_FCOverrideCustomerScopeRows, (a) => {
                return a.isActive && !_.isEmpty(a.WB_CustomerRow)
            }),
            (b) => b.WB_CustomerRow)
    }


    get AllProductGroups(): WB_ProductGroupRow[] {
        return this._allProductGroups
    }

    get ProductGroups(): WB_ProductGroupRow[] {
        return _.map(_.filter(this.WB_Override.WB_FCOverrideProductScopeRows, (a) => {
                return a.isActive && !_.isEmpty(a.WB_ProductGroupRow) && (a.cif.WB_PRDGRP_ID > 0)
            }),
            (b) => b.WB_ProductGroupRow)
    }

    getWbProdIds(wbPrdGrpId: number): number[] {
        if(wbPrdGrpId in this._dctWbProductIds)
            return this._dctWbProductIds[wbPrdGrpId] || []

        return []
    }

    get CustomerEntitySource(): IEntitySource {
        return this.custEntitySource
    }

    get ProductEntitySource(): IEntitySource {
        return this.prdEntitySource
    }

    async addCustomer(wbCustId: number): Promise<WB_FC_Override_CustomerRow> {
        const self = this;
        //--
        for (const a of this.WB_Override.WB_FCOverrideCustomerScopeRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_CUST_ID == wbCustId)
                return a;
        }

        const cust = <WB_CustomerRow>await self.dbContext.find(esWB_Customer, wbCustId);
        if (_.isEmpty(cust))
            return undefined;

        const newRow = <WB_FC_Override_CustomerRow>await self.dbContext.createRecordWithKey(esWB_FC_Override_Customer);
        newRow.cif.WB_OVRD_ID = self.WB_Override.cif.WB_OVRD_ID;
        newRow.WB_FCOverrideRow = self.WB_Override;
        newRow.cif.WB_CUST_ID = wbCustId;
        newRow.WB_CustomerRow = cust;
        self.dbContext.add(esWB_FC_Override_Customer, newRow)
        self.OnCustomersChanged.next(self)
        return newRow;
    }

    async removeCustomer(wbCustId: number): Promise<void> {
        const self = this;
        //--
        for (const a of this.WB_Override.WB_FCOverrideCustomerScopeRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_CUST_ID == wbCustId)
                a.markDeleted();
        }
        self.OnCustomersChanged.next(self)
    }

    async addProductGroup(wbPrdGrpId: number): Promise<WB_FC_Override_ProductRow> {
        const self = this;
        //--
        for (const a of this.WB_Override.WB_FCOverrideProductScopeRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_PRDGRP_ID == wbPrdGrpId)
                return a;
        }

        const pg = <WB_ProductGroupRow>await self.dbContext.find(esWB_Product_Group, wbPrdGrpId);
        if (_.isEmpty(pg))
            return undefined;

        const newRow = <WB_FC_Override_ProductRow>await self.dbContext.createRecordWithKey(esWB_FC_Override_Product);
        newRow.cif.WB_OVRD_ID = self.WB_Override.cif.WB_OVRD_ID;
        newRow.WB_FCOverrideRow = self.WB_Override;
        newRow.cif.WB_PRDGRP_ID = wbPrdGrpId;
        newRow.WB_ProductGroupRow = pg;
        self.dbContext.add(esWB_FC_Override_Product, newRow)
        self.OnProductsChanged.next(self)

        return newRow;
    }

    async removeProductGroup(wbPrdGrpId: number): Promise<void> {
        const self = this;
        //--
        if (!(wbPrdGrpId > 0))
            return

        for (const a of this.WB_Override.WB_FCOverrideProductScopeRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_PRDGRP_ID == wbPrdGrpId)
                a.markDeleted();
        }
        self.OnProductsChanged.next(self)

    }


    //</editor-fold>



    //<editor-fold desc = "Period operations">

    private _Periods: IConsumptionPeriod[]
    private _allPeriods: IConsumptionPeriod[]
    private _periodsLoaded: boolean
    private _onPeriodsChanged: BehaviorSubject<ConsumptionOverrideBO>
    private _lock: AsyncLock
    private _periodsOnLoadComplete: Promise<void>

    private Period_init() {
        //--

        this._Periods = []
        this._allPeriods = []
        this._periodsLoaded = false
        this._onPeriodsChanged = new BehaviorSubject(undefined)
        this._lock = new AsyncLock()
        this._periodsOnLoadComplete = undefined

    }

    private async Period_OnLoadComplete(): Promise<void> {
        const self = this;

        if (!_.isUndefined(self._periodsOnLoadComplete))
            return self._periodsOnLoadComplete;

        self.WB_Override.setupOnChangeEvents(['CNS_START_DT', 'CNS_END_DT'], (rec, name, val) => {
            self.Period_updatePeriods()
        })

        self._periodsOnLoadComplete = (async () => {
            await self.Period_updatePeriods()
        })()


        return self._periodsOnLoadComplete;
    }

    private async Period_updatePeriods(): Promise<void> {
        const self = this

        await self._lock.acquire("sync", async (done) => {

            let startDt = self.WB_Override.CnsStartDt
            let endDt = self.WB_Override.CnsEndDt;


            if (!self._periodsLoaded) {
                self._periodsLoaded = true
                const vUI_Plan_Cnsmp_Period_Dates_Schema = PASearch.createSimpleSchema(['START_DT','END_DT'],['WB_PLAN_ID','WB_CUST_ID_PLANNING'])

                let periodData: vUI_Plan_Cnsmp_Period_DatesRow[] = await PASearch.find('vUI_Plan_Cnsmp_Period_Dates', {WB_PLAN_ID: self.WB_Override.cif.WB_PLAN_ID},vUI_Plan_Cnsmp_Period_Dates_Schema,['END_DT', 'START_DT'],0,[] )

                this._allPeriods = []
                _.forEach(periodData, (aRow) => {

                    let cnsPrd: IConsumptionPeriod = {
                        key: aRow.END_DT,
                        name: DateUtils.formatDate(DateUtils.convertFromSAPBW(aRow.END_DT)),
                        startDt: DateUtils.convertFromSAPBW(aRow.START_DT),
                        endDt: DateUtils.convertFromSAPBW(aRow.END_DT)
                    }
                    this._allPeriods.push(cnsPrd)
                })

            }

            let periods: IConsumptionPeriod[] = []
            if (DateUtils.isLessThanEqual(startDt, endDt)) {
                periods = _.filter(this._allPeriods, (p) => DateUtils.RangeDatesOverlap(startDt, endDt, p.startDt, p.endDt))
                this._Periods = periods
            } else {
                // Don't change anything, avoid deleting stuff when dates invalid
            }

            self.OnPeriodsChanged.next(self)
            done()
        });

    }

    get Periods(): IConsumptionPeriod[] {
        return this._Periods
    }

    get OnPeriodsChanged(): BehaviorSubject<ConsumptionOverrideBO> {
        return this._onPeriodsChanged
    }

    //</editor-fold>


    //<editor-fold desc = "ICubeSource Override operations">
    private _bICubeSourceOverrideLoaded: boolean
    private _onICubeSourceOverrideLoaded: Promise<void>
    private _cubeSourceOverride: CubeSource

    private _qsCubeSourceOverride_sync: ExecutionSerializer
    private _cubeSourceSyncProgressProvider: IProgressProvider
    private _cubeSourceSyncMessageProvider: IMessageProvider
    private _subCubeSourceCustChange: Subscription = undefined
    private _subCubeSourcePrdChange: Subscription = undefined
    private _subCubeSourcePeriodChange: Subscription = undefined

    private _qsCubeSourceOverride_reloadSource: ExecutionSerializer
    private _cubeSourceReloadSourceProgressProvider: IProgressProvider
    private _cubeSourceReloadSourceMessageProvider: IMessageProvider



    private ICubeSourceOverride_init() {
        this._bICubeSourceOverrideLoaded = false
        this._cubeSourceOverride = undefined
        this._cubeSourceSyncProgressProvider = new ProgressProvider("Synchronize Scope")
        this._cubeSourceSyncMessageProvider = new MessageProvider()
        this._qsCubeSourceOverride_sync = new ExecutionSerializer(this, this._CubeSourceDataRow_sync.bind(this),
            [{}], 250, true)

        this._cubeSourceReloadSourceProgressProvider = new ProgressProvider("Load Source Data")
        this._cubeSourceReloadSourceMessageProvider = new MessageProvider()

        this._qsCubeSourceOverride_reloadSource = new ExecutionSerializer(this, this._CubeSourceDataRow_reloadSource.bind(this),
            [{}], 250, true)

    }

    ICubeSource_beforeReload() {

        this._bICubeSourceOverrideLoaded = false

        // Reset the CubeSource Queue
        if (this._subCubeSourceCustChange) {
            this._subCubeSourceCustChange.unsubscribe()
            this._subCubeSourceCustChange = undefined
        }

        if (this._subCubeSourcePrdChange) {
            this._subCubeSourcePrdChange.unsubscribe()
            this._subCubeSourcePrdChange = undefined
        }
        if (this._subCubeSourcePeriodChange) {
            this._subCubeSourcePeriodChange.unsubscribe()
            this._subCubeSourcePeriodChange = undefined
        }
    }

    get CubeSourceSyncProgressProvider(): IProgressProvider {
        return this._cubeSourceSyncProgressProvider
    }

    get CubeSourceSyncMessageProvider(): IMessageProvider {
        return this._cubeSourceSyncMessageProvider
    }

    private async ICubeSource_OnLoadComplete(): Promise<void> {
        const self = this

        self._subCubeSourceCustChange = self.OnCustomersChanged.subscribe((bo) => {
            if (_.isEmpty(bo)) return
            if (self.bIsLoaded) {
                self.CubeSource_sync()
            }
        })

        self._subCubeSourcePrdChange = self.OnProductsChanged.subscribe((bo) => {
            if (_.isEmpty(bo)) return
            if (self.bIsLoaded) {
                self.CubeSource_sync()
            }
        })

        self._subCubeSourcePeriodChange = self.OnPeriodsChanged.subscribe((bo) => {
            if (_.isEmpty(bo)) return
            if (self.bIsLoaded) {
                self.CubeSource_sync()
            }
        })

    }


    get bICubeSourceOverrideLoaded(): boolean {
        return this._bICubeSourceOverrideLoaded
    }

    get OnICubeSourceOverrideLoaded(): Promise<void> {
        const self = this

        // prevent duplicate initialization
        if(!_.isUndefined(self._onICubeSourceOverrideLoaded))
            return self._onICubeSourceOverrideLoaded

        let rv = self._onICubeSourceOverrideLoaded = (async () => {

            if (!self.bIsLoaded)
                await self.OnLoadComplete

            const arrKnownCstKeys = _.map(self.Customers, (a) => a.cif.WB_CUST_ID)
            const arrKnownPrdGrpKeys = _.map(self.ProductGroups, (a) => a.cif.WB_PRDGRP_ID)
            const arrKnownPeriodKeys = _.map(self.Periods, (a) => a.key)

            self._cubeSourceOverride = new CubeSource({
                CubeSourceId: 'ConsumptionOverride',
                Parameters: { Override: [self.WB_Override.cif.WB_OVRD_ID] },
                dbContext: self.dbContext,
                DimensionPolicyOptions: {
                    CubeSource: undefined,
                    WB_PlanRow: self.WB_Override.WB_PlanRow,
                    WB_ConsumptionOverrideRow: self.WB_Override,
                    EffectiveStartDt: self.WB_Override.WB_PlanRow?.InStore?.Range?.StartDt,
                    EffectiveEndDt: self.WB_Override.WB_PlanRow?.InStore?.Range?.EndDt
                },
                LoadOptions: {
                    Overrides: {
                        [DimensionType.Customer]: { bEnableLazyLoading: false },
                        [DimensionType.Product]: { bEnableLazyLoading: false },
                        [DimensionType.Time]: { bEnableLazyLoading: false }
                    }
                },
                KnownKeyOptions: {
                    Overrides: {
                        [DimensionType.Customer]: {
                            bUseKnownKeys: true,
                            KnownLeafKeys: arrKnownCstKeys
                        },
                        [DimensionType.Product]: {
                            bUseKnownKeys: true,
                            KnownLeafKeys: arrKnownPrdGrpKeys
                        },
                        [DimensionType.Time]: {
                            bUseKnownKeys: true,
                            KnownLeafKeys: arrKnownPeriodKeys
                        }
                    }
                },
                KeyFieldPolicyOptions: {
                    KeyFieldNameProd: 'WB_PRDGRP_ID'
                },
                UOMPolicyOptions: {},
                UOMConverterOptions: {},
                DataSourceOptions: {
                    Overrides: {
                        RecordResolverOptions: {
                            dctExcludeHasManyNamedRelations: {  },
                            standardConditions: {
                                [esWB_FC_Override_Consumption]: {DELETED_IND: {neq: '1'}}
                            }
                        }
                    }
                }
            })

            await self._cubeSourceOverride.OnICubeSourceLoadComplete

            self._cubeSourceOverride.setEnabled(self.PolicyCollection.BOis.Editable &&
                !_.includes(['Applied','Deactivated'], self.WB_Override.cif.OVRD_STATUS))

            self.defaultHRViews()

            self._bICubeSourceOverrideLoaded = true

        })();

        return rv
    }

    get CubeSource(): ICubeSource {
        return this._cubeSourceOverride
    }

    CubeSource_onPrdGrpAdd(prdGrp: WB_ProductGroupRow): void {
        const self = this
        if (_.isEmpty(prdGrp))
            return

        // Notify Datasource has loaded PG
        let ds: DataSourceJSData = <DataSourceJSData>self._cubeSourceOverride.getDataSource("Overrides")
        ds.setLoadedKeys(DimensionType.Product, prdGrp.cif.WB_PRDGRP_ID)

    }

    CubeSource_onCustAdd(cust: WB_CustomerRow): void {
        const self = this
        if (_.isEmpty(cust))
            return

        // Notify Datasource has loaded Cust
        let ds: DataSourceJSData = <DataSourceJSData>self._cubeSourceOverride.getDataSource("Overrides")
        ds.setLoadedKeys(DimensionType.Customer, cust.cif.WB_CUST_ID)
    }

    CubeSource_onPeriodAdd(perd: IConsumptionPeriod): void {
        const self = this
        if (_.isEmpty(perd))
            return

        // Notify Datasource has loaded Period
        let ds: DataSourceJSData = <DataSourceJSData>self._cubeSourceOverride.getDataSource("Overrides")
        ds.setLoadedKeys(DimensionType.Time, perd.key)
    }


    CubeSource_sync(): void {

        // Debounce calls ...
        console.log("Synchronizing CubeSource: qsRun")
        this._qsCubeSourceOverride_sync.Run({})
    }

    private async _CubeSourceDataRow_sync(opts: any): Promise<void> {
        const self = this

        let pp = self._cubeSourceSyncProgressProvider
        let mp = self._cubeSourceSyncMessageProvider

        try {

            if (!self.bICubeSourceOverrideLoaded)
                await self.OnICubeSourceOverrideLoaded

            if (_.isEmpty(self._cubeSourceOverride))
                return

            if(!self._cubeSourceOverride.bICubeSourceLoaded)
                await self._cubeSourceOverride.OnICubeSourceLoadComplete

            mp.clearMessages()
            pp.start("Sync Scope")

            for (const dsAlias of ["Overrides"]) {
                // Sync records to DataSources,
                // Set Known Keys

                const dsDataSource: DataSourceJSData = <DataSourceJSData>self._cubeSourceOverride.getDataSource(dsAlias)
                if(_.isEmpty(dsDataSource))
                    continue

                // Determine the Customers, Product Groups & Weeks... and create sync the combination of records..
                // Determine Cust Scope
                let arrCustomers: WB_CustomerRow[] = []
                arrCustomers = self.Customers
                const dctCustomers = _.keyBy(arrCustomers, (aCst) => aCst.cif.WB_CUST_ID)
                arrCustomers = _.values(dctCustomers)

                // Determine PG Scope
                let arrProductGroups: WB_ProductGroupRow[] = []
                arrProductGroups = self.ProductGroups
                const dctProductGroups = _.keyBy(arrProductGroups, (aPG) => aPG.cif.WB_PRDGRP_ID)
                arrProductGroups = _.values(dctProductGroups)

                // Determine Period Scope
                const arrPeriods: IConsumptionPeriod[] = self.Periods
                const dctPeriods: {
                    [id: number]: IConsumptionPeriod
                } = _.keyBy(arrPeriods, (aPrd: IConsumptionPeriod) => aPrd.key)


                const dctMetricsRow: { [id: string]: WB_FC_Override_ConsumptionRow } = {}
                // Create Dictionary... deleting duplicate rows, and rows not in scope
                const removeKeys: number[] = []
                const addRows: WB_FC_Override_ConsumptionRow[] = []

                const loadedRows: WB_FC_Override_ConsumptionRow[] = <WB_FC_Override_ConsumptionRow[]>dsDataSource.LoadedRows

                _.forEach(loadedRows, (aRow) => {
                    if (!aRow.isActive) {
                        removeKeys.push(aRow.Row_Id)
                        return
                    }

                    // Check if the Customer, Product Group or Period isn't in the dataset
                    if (!(aRow.cif.WB_CUST_ID_SOURCE in dctCustomers)) {
                        // Remove extra Customer
                        aRow.markDeleted()
                        removeKeys.push(aRow.Row_Id)
                        return
                    }

                    if (!(aRow.cif.WB_PRDGRP_ID in dctProductGroups)) {
                        // Remove extra Product Group
                        aRow.markDeleted()
                        removeKeys.push(aRow.Row_Id)
                        return
                    }

                    if (!(aRow.cif.END_DT in dctPeriods)) {
                        // Remove extra Period
                        aRow.markDeleted()
                        removeKeys.push(aRow.Row_Id)
                        return
                    }

                    const logicalKey = aRow.cif.WB_CUST_ID_SOURCE + '-' + aRow.cif.WB_PRDGRP_ID + '-' + aRow.cif.END_DT

                    if (logicalKey in dctMetricsRow) {
                        // Remove Duplicate Row
                        aRow.markDeleted()
                        removeKeys.push(aRow.Row_Id)
                        return
                    }

                    dctMetricsRow[logicalKey] = aRow

                }) // Next Row to check for Delete

                // Create Missing Rows
                // get Period Records from this dbContext..
                for (let idxCust = 0; idxCust < arrCustomers.length; idxCust++) {
                    const aCustomerRow = arrCustomers[idxCust]
                    for (let idxPG = 0; idxPG < arrProductGroups.length; idxPG++) {
                        const aProductGroupRow = arrProductGroups[idxPG]
                        for (let idxPeriod = 0; idxPeriod < arrPeriods.length; idxPeriod++) {
                            const aPeriodRow = arrPeriods[idxPeriod]

                            const logicalKey = aCustomerRow.cif.WB_CUST_ID + '-' + aProductGroupRow.cif.WB_PRDGRP_ID + '-' + aPeriodRow.key
                            if (logicalKey in dctMetricsRow) {
                                continue
                            }

                            // Create Missing Record.. add to Dictionary.
                            switch (dsAlias) {
                                case "Overrides": {
                                    const newRecord: WB_FC_Override_ConsumptionRow = <any>await self.dbContext.createRecordWithKey(esWB_FC_Override_Consumption)
                                    newRecord.setDefaults()
                                    newRecord.cif.WB_OVRD_ID = self.WB_Override.cif.WB_OVRD_ID
                                    newRecord.WB_FCOverrideRow = self.WB_Override
                                    newRecord.cif.WB_CUST_ID_SOURCE = aCustomerRow.cif.WB_CUST_ID
                                    newRecord.WB_CustomerRow = aCustomerRow
                                    newRecord.cif.WB_PRDGRP_ID = aProductGroupRow.cif.WB_PRDGRP_ID
                                    newRecord.WB_ProductGroupRow = aProductGroupRow
                                    newRecord.cif.END_DT = aPeriodRow.key
                                    newRecord.cif.START_DT = DateUtils.convertToSAPBW(aPeriodRow.startDt)
                                    self.dbContext.add(esWB_FC_Override_Consumption, newRecord)
                                    addRows.push(newRecord)
                                }
                                    break;
                            }
                        } // Next Period
                    } // Next PG
                }

                // Remove Old, Add Missing, Set Known Keys
                if (!_.isEmpty(removeKeys)) {
                    console.log(`Removing Rows from DataSource, ${removeKeys.length} records`)
                    dsDataSource.remove(removeKeys)
                    console.log(`Completed Removing Rows from DataSource, ${removeKeys.length} records`)
                }

                if (!_.isEmpty(addRows)) {
                    console.log(`Adding Rows to DataSource, ${addRows.length} new records`)
                    dsDataSource.add(addRows)
                    console.log(`Completed Adding Rows to DataSource, ${addRows.length} new records`)
                }

                dsDataSource.setKnownKeyOptions({
                    [DimensionType.Customer]: {
                        bUseKnownKeys: true,
                        KnownLeafKeys: _.map(arrCustomers, (a) => a.cif.WB_CUST_ID)
                    },
                    [DimensionType.Product]: {
                        bUseKnownKeys: true,
                        KnownLeafKeys: _.map(arrProductGroups, (a) => a.cif.WB_PRDGRP_ID)
                    },
                    [DimensionType.Time]: {
                        bUseKnownKeys: true,
                        KnownLeafKeys: _.map(arrPeriods, (a) => a.key)
                    }
                })

                if (!_.isEmpty(addRows)) {
                    console.log(`Loading Consumption data for ${addRows.length} new records`)
                    await self.LoadSyndicatedConsumption(addRows, true)
                    console.log(`Completed Loading Consumption data for ${addRows.length} new records`)
                }


                } //-- Repeat for Next Alias

            pp.finish()

            this._cubeSourceOverride.OnCubeSourcePropertyChange.next({Source: this._cubeSourceOverride, PropertyName: "Perspective", PropertyValue: undefined})


        } catch (err) {
            console.log("Error in Sync: ", err)
            pp.exception(err)
            ExceptionMessage_restate(mp, err)
            throw err
        }

    }

    private defaultHRViews() {
        const self = this

        const cs = self._cubeSourceOverride


    }

    get CubeSourceReloadSourceProgressProvider(): IProgressProvider {
        return this._cubeSourceReloadSourceProgressProvider
    }

    get CubeSourceReloadSourceMessageProvider(): IMessageProvider {
        return this._cubeSourceReloadSourceMessageProvider
    }


    CubeSource_reloadSource(): void {

        // Debounce calls ...
        console.log("Reload Source Data: qsRun")
        this._qsCubeSourceOverride_reloadSource.Run({})
    }

    async _CubeSourceDataRow_reloadSource(): Promise<void> {
        const self = this

        let pp = self._cubeSourceReloadSourceProgressProvider
        let mp = self._cubeSourceReloadSourceMessageProvider

        //--
        try {
            mp.clearMessages()
            pp.start();
            let cnsRows = _.filter(self.WB_Override.WB_FC_Override_ConsumptionRows, (r) => r.isActive)
            if (!_.isEmpty(cnsRows))
                await self.LoadSyndicatedConsumption(cnsRows, false, pp)

            pp.finish()

            this._cubeSourceOverride.OnCubeSourcePropertyChange.next({Source: this._cubeSourceOverride, PropertyName: "Perspective", PropertyValue: undefined})

        } catch(err) {
            pp.exception(err)
            ExceptionMessage_restate(mp, err)
        }

    }

    async LoadSyndicatedConsumption(wbOverrideCnsRows: WB_FC_Override_ConsumptionRow[], bInitOverrides: boolean, progressProvider?: IProgressProvider): Promise<void> {
        const self = this

        let aMetricService = new PAMetricServiceClient()
        let pp = progressProvider
        if(_.isEmpty(pp))
            pp = new ProgressProvider()

        // Use the metric service to retrieve consumption

        let arrChunks = _.chunk(wbOverrideCnsRows, 250)
        pp.setProgressDenominator(arrChunks.length)
        let chunkIdx = 0
        for(let chunk of arrChunks) {
            pp.setProgressNumerator(chunkIdx)

            let mps = new MetricsParameterSet()

            for(let aRow of chunk){
                let aMP = new MetricParameters()
                aMP.MetricParameterId = aRow.cif.WB_OVRD_CNS_ID + ''
                aMP.bCalculateIntersection = false
                aMP.PlanningCustomers.push(self.WB_Override.WB_PlanRow.cif.WB_CUST_ID_PLANNING)
                aMP.SourceCustomers.push(aRow.cif.WB_CUST_ID_SOURCE)
                aMP.FinishedProducts = self.getWbProdIds(aRow.cif.WB_PRDGRP_ID)
                aMP.InStoreStartDt = DateUtils.convertFromSAPBW(aRow.cif.START_DT)
                aMP.InStoreEndDt = DateUtils.convertFromSAPBW(aRow.cif.END_DT)
                if(_.isEmpty(aMP.FinishedProducts)){
                    aMP.FinishedProducts = [-1]
                }

                aMP.bIncludeAdjustments = false
                aMP.bIncludeEDLPSplit = false
                mps[aMP.MetricParameterId] = aMP
            }

            let metricSet = await aMetricService.calculateMetricSet(mps)
            for(let aRow of chunk) {
                let key = aRow.cif.WB_OVRD_CNS_ID + ''
                if(key in metricSet){
                    let mtr = metricSet[key]
                    if(_.isEmpty(mtr))
                        continue

                    let rec = aRow.cif
                    rec.SYND_BASE_PRICE = mtr.RETAILER_BASE_PRICE
                    rec.SYND_PROMOTED_PRICE = mtr.RETAILER_PROMOTED_PRICE
                    rec.SYND_COVERAGE_FACTOR = 1
                    rec.SYND_CNS_BASE_UNITS = mtr.CNSMP_SYND_BASE_UNITS
                    rec.SYND_CNS_BASE_WT = mtr.CNSMP_SYND_BASE_WT
                    rec.SYND_CNS_BASE_STAT = mtr.CNSMP_SYND_BASE_STAT
                    rec.SYND_CNS_BASE_RTLSLS = mtr.CNSMP_SYND_BASE_RTLSLS

                    rec.SYND_CNS_PROMOBASE_UNITS = mtr.CNSMP_PROMO_UNITS - mtr.CNSMP_INCR_UNITS
                    rec.SYND_CNS_PROMOBASE_WT = mtr.CNSMP_PROMO_WT - mtr.CNSMP_INCR_WT
                    rec.SYND_CNS_PROMOBASE_STAT = mtr.CNSMP_PROMO_STAT - mtr.CNSMP_INCR_STAT
                    rec.SYND_CNS_PROMOBASE_RTLSLS = mtr.CNSMP_PROMO_RTLSLS - mtr.CNSMP_INCR_RTLSLS

                    rec.SYND_CNS_INCR_UNITS = mtr.CNSMP_INCR_UNITS
                    rec.SYND_CNS_INCR_WT = mtr.CNSMP_INCR_WT
                    rec.SYND_CNS_INCR_STAT = mtr.CNSMP_INCR_STAT
                    rec.SYND_CNS_INCR_RTLSLS = mtr.CNSMP_INCR_RTLSLS

                    rec.SYND_CNS_DISP_INCR_UNITS = mtr.CNSMP_DISP_INCR_UNITS
                    rec.SYND_CNS_DISP_INCR_WT = mtr.CNSMP_DISP_INCR_WT
                    rec.SYND_CNS_DISP_INCR_STAT = mtr.CNSMP_DISP_INCR_STAT
                    rec.SYND_CNS_DISP_INCR_RTLSLS = mtr.CNSMP_DISP_INCR_RTLSLS


                    rec.SYND_CNS_TOTAL_UNITS = mtr.CNSMP_TOTAL_UNITS
                    rec.SYND_CNS_TOTAL_WT = mtr.CNSMP_TOTAL_WT
                    rec.SYND_CNS_TOTAL_STAT = mtr.CNSMP_TOTAL_STAT
                    rec.SYND_CNS_TOTAL_RTLSLS = mtr.CNSMP_TOTAL_RTLSLS

                    rec.WT_UOM_PER_UNIT = ((mtr.CNSMP_TOTAL_UNITS > 0)? mtr.CNSMP_TOTAL_WT / mtr.CNSMP_TOTAL_UNITS : 0)
                    rec.STAT_UOM_PER_UNIT = ((mtr.CNSMP_TOTAL_UNITS > 0)? mtr.CNSMP_TOTAL_STAT / mtr.CNSMP_TOTAL_UNITS : 0)
                    rec.RTLSLS_UOM_PER_UNIT = ((mtr.CNSMP_TOTAL_UNITS > 0)? mtr.CNSMP_TOTAL_RTLSLS / mtr.CNSMP_TOTAL_UNITS : 0)
                    rec.RTLSLS_UOM_PER_BASE_UNIT = ((mtr.CNSMP_SYND_BASE_UNITS > 0)? mtr.CNSMP_SYND_BASE_RTLSLS / mtr.CNSMP_SYND_BASE_UNITS : rec.RTLSLS_UOM_PER_UNIT)
                    rec.RTLSLS_UOM_PER_INCR_UNIT = ((mtr.CNSMP_INCR_UNITS > 0)? mtr.CNSMP_INCR_RTLSLS / mtr.CNSMP_INCR_UNITS : rec.RTLSLS_UOM_PER_UNIT)

                    if(bInitOverrides){
                        rec.BASE_OVRD = rec.SYND_CNS_BASE_UNITS
                        rec.EDLP_OVRD = 0
                        rec.MERCH_INCR_OVRD = rec.SYND_CNS_INCR_UNITS
                        rec.DISPLAY_INCR_OVRD = mtr.CNSMP_DISP_INCR_UNITS


                    }
                }
            }
            chunkIdx++
        }
        pp.setProgressNumerator(chunkIdx)

    }


    //</editor-fold>





    async ReloadCnsOverrides(): Promise<void> {
        const self = this

        const purgeScope = { ["Customer"]: { bAll: true } }
        self._cubeSourceOverride.purgeScope(purgeScope, "Overrides")
    }




    //<editor-fold desc = "IRecordResolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        const opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const scope_options: CreateOptions = {
            standardConditions: {
                [esWB_FC_Override]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_FC_Override_Customer]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_FC_Override_Product]: { "DELETED_IND": { "notIn": ['1'] } }
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Plan]: [esWB_Plan_Type]
            },
            dctExcludeHasManyNamedRelations: {
                [esWB_FC_Override]: [
                    esWB_FC_Override_Consumption,
                    esWB_FC_Override_Event_Date,
                    esWB_FC_Override_Event_Volume,
                    esWB_FC_Override_Event_Spend,
                    esWB_FC_Override_Event_Spend_Redistribution,
                    esWB_FC_Override_Event_Product,
                    esWB_FC_Override_Event_Merge
                ]
            }


        }

        const aRecResolver = new ESRecordResolver(dbContext, scope_options)

        return aRecResolver;

    }

    static async setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {
        await recordResolver.findAllWithRelationships(esWB_FC_Override, ids)
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>

};

PAEnvironment.registerBusinessObjectClass(ConsumptionOverrideBO, "ConsumptionOverrideBO", "Consumption Override")
